import { Component } from '@angular/core';

@Component({
  selector: 'ngx-email-marketing',
  templateUrl: './email-marketing.component.html',
  styleUrls: ['./email-marketing.component.scss']
})
export class EmailMarketingComponent {

}
